"use strict";

import angular from "angular";

import template from "./library-item.component.html";
import "./themes/library-item.component.scss";
import "./themes/library-item.component-dark.scss";

class LibraryItemComponent {
    constructor() {}

    $onInit() {}

    $onChanges(changes) {}
}

export { LibraryItemComponent };

LibraryItemComponent.$inject = [];

const name = "libraryItemComponent";
const def = {
    bindings: {
            name: "<",
            badge: "<",
            active: "<"
        },
        transclude: true,
        controller: LibraryItemComponent,
    template
};
angular.module("nucont.shared").component(name, def);
export default { name, ...def };
